import React from 'react';
import { Card, CardContent, Stack, Typography } from '@mui/material';

function ResponsiveDataList({ rows, getTitle, getSubtitle, renderFields, renderActions, onRowClick }) {
  return (
    <Stack spacing={1.5}>
      {rows.map((row) => (
        <Card
          key={row.id}
          variant="outlined"
          onClick={onRowClick ? () => onRowClick(row) : undefined}
          sx={onRowClick ? { cursor: 'pointer' } : undefined}
        >
          <CardContent sx={{ pb: '12px !important' }}>
            <Typography variant="subtitle1" fontWeight={600}>
              {getTitle(row)}
            </Typography>
            {getSubtitle ? (
              <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                {getSubtitle(row)}
              </Typography>
            ) : null}
            {renderFields ? renderFields(row) : null}
            {renderActions ? (
              <Stack
                direction="row"
                spacing={1}
                flexWrap="wrap"
                sx={{ mt: 1 }}
                onClick={onRowClick ? (event) => event.stopPropagation() : undefined}
              >
                {renderActions(row)}
              </Stack>
            ) : null}
          </CardContent>
        </Card>
      ))}
    </Stack>
  );
}

export default ResponsiveDataList;
